import axios, { AxiosResponse } from 'axios';
import { getAccessToken } from './accessToken';
import { URL_LIBRANZAS, LIBRANZAS_APIKEY } from '@/constants/api-constants';

const BUYER_DOC_TYPE_MAP: Record<string, string> = {
    CO1C: 'CC',
    CO1E: 'CE',
    CO1N: 'NIT',
};

export interface HistorialLibranzasPayload {
    buyerDocumentCompany: string;
    buyerDocumentTypeCompany: string;
    userDocumentType?: string;
    userDocumentNumber?: string;
    fechaInicio?: string;
    fechaFin?: string;
}

export const getHistorialLibranzas = (payload: HistorialLibranzasPayload): Promise<AxiosResponse | undefined> =>
    getAccessToken()
        .then((tokenResponse) => {
            const token = tokenResponse?.data.data.id_token;
            const adaptedPayload = {
                ...payload,
                buyerDocumentTypeCompany: BUYER_DOC_TYPE_MAP[payload.buyerDocumentTypeCompany] ?? payload.buyerDocumentTypeCompany,
            };
            return axios.request({
                method: 'post',
                url: `${URL_LIBRANZAS}/transactions/history`,
                headers: {
                    apikey: LIBRANZAS_APIKEY,
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                data: adaptedPayload,
            });
        })
        .catch((error) => {
            if (error.response?.status === 404) return error.response;
            console.error(error);
            return undefined;
        });
